import React from "react";
import Button from "../../../Button";
import PropType from "prop-types";

export default function OptionCard(props) {
  const price = props.price;

  function formatPrice(price) {
    return "$" + price / 100;
  }

  return (
    <div className="option-card-container">
      <h1 className="option-card-cost">
        {formatPrice(price.unitAmount)} / {price.recurring.interval}
      </h1>
      <Button onClick={props.onClick} name={price.id}>
        Sign Up
      </Button>
    </div>
  );
}

OptionCard.propTypes = {
  price: PropType.node.isRequired,
  onClick: PropType.func.isRequired,
};
